<template>
  <a :href="link" class="fm-contextual-help" target="_blank">
    <md-icon>help</md-icon
    ><md-tooltip md-direction="top">{{ tooltipText }}</md-tooltip>
  </a>
</template>
<script>
export default {
  props: {
    link: null,
    tooltipText: String,
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/md/variables";
.fm-contextual-help {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: linear-gradient(60deg, $brand-primary, $brand-primary);
  border-radius: 11px;
  height: 22px !important;
  width: 22px;
  margin-right: 30px;
  .md-icon {
    font-size: 20px !important;
    min-width: 22px !important;
    width: 22px !important;
    height: 22px !important;
    color: white !important;
    line-height: 0px !important;
  }
}
.md-tooltip {
  transform: translate(10px);
}
</style>
